/** Display grouping for the filter multi-select. Mirrors the backend
 *  SELF_SERVICE_VISIBLE_TYPES allowlist (crates/sentinel-domain audit.rs). */
export const EVENT_TYPE_GROUPS: { category: string; types: string[] }[] = [
  {
    category: 'auth',
    types: [
      'login_succeeded', 'login_failed', 'sso_login_succeeded', 'sso_login_failed',
      'logout', 'rp_logout', 'register', 'password_reset_requested',
      'password_reset_confirmed', 'email_verified', 'verification_resent',
      'account_locked', 'account_unlocked', 'account_linked', 'account_unlinked',
    ],
  },
  {
    category: 'mfa',
    types: [
      'mfa_enrolled', 'mfa_verified', 'mfa_disabled', 'mfa_recovery_used',
      'mfa_recovery_codes_regenerated', 'step_up_succeeded', 'step_up_failed',
      'mcp_step_up_granted',
    ],
  },
  {
    category: 'passkey',
    types: [
      'web_authn_registered', 'web_authn_authenticated', 'web_authn_deleted',
      'web_authn_renamed', 'web_authn_clone_detected',
    ],
  },
  {
    category: 'passwordless',
    types: [
      'magic_link_sent', 'magic_link_verified', 'magic_link_failed',
      'email_otp_sent', 'email_otp_verified', 'email_otp_failed',
    ],
  },
  {
    category: 'account',
    types: [
      'profile_updated', 'email_change_requested', 'email_change_confirmed',
      'password_changed', 'password_change_failed', 'account_deleted', 'data_exported',
    ],
  },
  {
    category: 'security',
    types: [
      'token_reuse_detected', 'token_revoked', 'suspicious_login_detected',
      'consent_granted', 'consent_revoked', 'consent_denied', 'mcp_secret_revealed',
    ],
  },
];

/** Title-cases a snake_case tag as a last-resort label when no i18n key exists. */
export function humanizeEventType(tag: string): string {
  return tag
    .split('_')
    .map((w) => (w ? w.charAt(0).toUpperCase() + w.slice(1) : w))
    .join(' ');
}

/** i18n key for an event type label, e.g. `eventTypes.login_succeeded`. */
export function eventTypeKey(tag: string): string {
  return `eventTypes.${tag}`;
}
